'use client'

import { useCallback, useState } from "react";

export const useModal = () => {
    const [isVisible, setIsVisible] = useState(false);

    const open = useCallback(() => {
        setIsVisible(true)
    }, [setIsVisible]);

    const hide = useCallback(() => {
        setIsVisible(false)
    }, [setIsVisible])

    return {
        isVisible,
        open,
        hide
    }
}